import createApiClient from '@/api/axiosInstance';
import { Button } from '@/components/ui/button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

// Status Component
const quote_status = (val) => (
  <div
    className={`inline-flex gap-2 p-1 justify-center rounded-full items-center text-xs font-medium
      ${val === 'Quote Accepted' && 'bg-[#ebfcee] text-[#33d84c] w-32'}
      ${val === 'Awaiting Team Review' && 'bg-[#e6f4f9] text-[#008dc1] w-40'}
      ${val === 'Contract Signed' && 'bg-[#faebf6] text-[#c42e9c] w-32'}
    `}
  >
    <div
      className={`w-2 h-2 rounded-full
        ${val === 'Quote Accepted' && 'bg-[#33d84c]'}
        ${val === 'Awaiting Team Review' && 'bg-[#008dc1]'}
        ${val === 'Contract Signed' && 'bg-[#c42e9c]'}
      `}
    ></div>
    <div>{val}</div>
  </div>
);

// Action Buttons
const buttons = (val, setScreen, setPO, item) => {
  const handleActionButton = (val) => {
    switch (val) {
      case 'Quote Accepted':
        setPO(item);
        setScreen('CREATE_PO');
        break;

      default:
        setPO(item);
        setScreen('SEND_PO');
        break;
    }
  };

  const buttonTextMap = {
    'Quote Accepted': 'Create PO',
    'Awaiting Team Review': 'Track Team Status',
    'Contract Signed': 'Send PO',
  };

  return (
    <Button
      className="bg-white border border-purple-500 text-purple-600 text-xs hover:bg-purple-50 px-3 py-1 rounded-md"
      onClick={() => handleActionButton(val)}
    >
      {buttonTextMap[val] || 'Proceed'}
    </Button>
  );
};
// Data
const tableDataContracts = [
  {
    part_name: 'Collection Bag',
    part_id: '1',
    quote_number: '123',
    manufacturer: 'Beta Tech',
    start_date: '1 July 2025',
    estimated_delivery: '25 July 2025',
    statusText: 'Quote Accepted',
  },
  {
    part_name: 'Collection Bag',
    part_id: '1',
    quote_number: '123',
    manufacturer: 'Beta Tech',
    start_date: '1 July 2025',
    estimated_delivery: '25 July 2025',
    statusText: 'Awaiting Team Review',
  },
  {
    part_name: 'Collection Bag',
    part_id: '1',
    quote_number: '123',
    manufacturer: 'Beta Tech',
    start_date: '1 July 2025',
    estimated_delivery: '25 July 2025',
    statusText: 'Contract Signed',
  },
];

const AllPartPOTable = ({ setScreen, setPO }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiClient = createApiClient(navigate, dispatch);
  const { projectId, projectName } = useParams();

  return (
    <div className="mt-2 font-roboto">
      <div className="grid grid-cols-7 items-center text-gray-600 text-center gap-4 py-2 bg-gray-50 rounded-md text-[14px] font-medium">
        <div className="text-left">Part</div>
        <div>Quote Number</div>
        <div>Manufacture</div>
        <div>Start Date</div>
        <div>Estimated Delivery</div>
        <div>Status</div>
        <div>Action</div>
      </div>

      {tableDataContracts.map((item, index) => (
        <div
          key={index}
          className="grid grid-cols-7 gap-4 py-4 items-center text-gray-700 text-sm border-b border-gray-200 bg-white hover:bg-veryVeryLightPurple transition-all ease-in duration-200"
        >
          <div className="text-left leading-4">
            <div className="font-medium">{item.part_name}</div>
            <div className="text-xs text-gray-400">{item.part_id}</div>
          </div>
          <div className="text-center">{item.quote_number}</div>
          <div className="text-center">{item.manufacturer}</div>
          <div className="text-center">{item.start_date}</div>
          <div className="text-center">{item.estimated_delivery}</div>
          <div className="text-center">{quote_status(item.statusText)}</div>
          <div className="text-center">
            {buttons(item.statusText, setScreen, setPO, item)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AllPartPOTable;
